export default {
    showErrors: true,
    airTemperature: {
        isValid: true,
        value: '0'
    },
    checkedItems: [],
    dischargeOrientation: {
        isValid: true,
        value: 'All'
    },
    height: {
        isValid: false,
        value: null
    },
    width: {
        isValid: false,
        value: null
    },
    pressure: {
        isValid: true,
        value: null
    },
    intakeexhaust: {
        isValid: true,
        value: "intake"
    },
    driveLoss: {
        disabled: true,
        isValid: true,
        value: '-1'
    },
    driveLossButton: {
        isValid: true,
        disabled: false,
        mode: 'AUTO',
        value: 'Auto'
    },
    driveType: {
        isValid: true,
        value: 'All'
    },
    altitude: {
        isValid: true,
        value: '0'
    },
    flow: {
        isValid: false,
        value: null
    },
    highWindRated: {
        isValid: true,
        value: 'All'
    },
    includeDriveLoss: {
        isValid: true,
        value: true
    },
    impellerType: {
        isValid: true,
        value: 'All'
    },
    restaurantExhaust: {
        isValid: true,
        value: 'All'
    },
    smokeControl: {
        isValid: true,
        value: 'All'
    },
    staticpressure: {
        isValid: true,
        value: null
    },
    sparkResistance: {
        isValid: true,
        value: 'All'
    },
    certification: {
        isValid: true,
        value: []
    },
    louverDepth: {
        isValid: true,
        value: []
    },
    material: {
        isValid: true,
        value: []
    },
    bladeType: {
        isValid: true,
        value: []
    },
    wpFactor: {
        isValid: true,
        value: 1.15
    },
    selectionmethod: {
        isValid: true,
        value: "1"
    }
};
